
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_LAST_TOPICS').plugin(axiosPlugin, {template: "array"});

let fetchLastTopicsAction = redux.fetchActionGet();

export const fetchLastTopics = () => fetchLastTopicsAction(`/features/topics`);

export const homeLastTopics = redux.reducer();